// extracted by mini-css-extract-plugin
export default {"root":"DuIT3","priority-primary":"_2_N5A","priorityPrimary":"_2_N5A","disabled":"_3Al0A","priority-secondary":"_12KLT","prioritySecondary":"_12KLT"};